import { Routes } from '@angular/router';
import { AuthGuard } from './authentication/helpers/auth.guard';
import { AppBlankComponent } from './layouts/blank/blank.component';
import { FullComponent } from './layouts/full/full.component';
import { MaintenanceComponent } from './shared/maintenance/maintenance.component';

export const AppRoutes: Routes = [
  {
    path: '',
    component: FullComponent,
    children: [
      {
        path: 'taxatie',
        loadChildren: () => import('./pages/valuation/valuation.module').then(m => m.ValuationModule),
        canActivate: [AuthGuard]
      },
      {
        path: 'overzicht',
        loadChildren: () => import('./pages/valuation/valuation.module').then(m => m.ValuationModule),
        canActivate: [AuthGuard]
      },
      {
        path: 'claim',
        loadChildren: () => import('./pages/claim/claim.module').then(m => m.ClaimModule),
        canActivate: [AuthGuard]
      },
      {
        path: 'crm',
        loadChildren: () => import('./pages/crm/crm.module').then(m => m.CrmModule),
        canActivate: [AuthGuard]
      },
      {
        path: 'inspectie',
        loadChildren: () => import('./pages/inspection/inspection.module').then(m => m.InspectionModule),
        canActivate: [AuthGuard]
      },
      {
        path: 'statistieken',
        loadChildren: () => import('./pages/statistics/statistics.module').then(m => m.StatisticsModule),
        canActivate: [AuthGuard]
      },
      {
        path: 'voertuig-lijst',
        loadChildren: () => import('./pages/vehicleList/vehicleList.module').then(m => m.VehicleListModule),
        canActivate: [AuthGuard]
      },
      {
        path: 'general',
        loadChildren: () => import('./pages/pages.module').then(m => m.PagesModule),
        canActivate: [AuthGuard]
      },
      {
        path: '',
        loadChildren: () => import('./pages/pages.module').then(m => m.PagesModule),
        pathMatch: 'full',
        canActivate: [AuthGuard]
      },
    ]
  },
  {
    path: 'authentication',
    component: AppBlankComponent,
    children: [
      {
        path: '',
        loadChildren:
          () => import('./authentication/authentication.module').then(m => m.AuthenticationModule)
      },
      {
        path: 'maintenance',
        component: MaintenanceComponent
      }
    ]
  },
  {
    path: '**',
    redirectTo: 'authentication/404'
  },
];
